import React, { useContext, useRef } from 'react';

// import { TradeDetailListSection } from './styles'
// import TradeDetailListHeader from './TradeDetailListHeader'
// import TradeDetailListItem from './TradeDetailListItem'
// import TradeDetailError from './TradeDetailError'
// import TradeDetailLoading from './TradeDetailLoading'
import { useFetcher } from '@app/hooks/fetcher';
import useTradeStore from '../../../../hooks/trade/tradeStore';

import { TradeDetailListSection, TradeText } from './styles';
import { useToken } from '@app/hooks';
import { AuthCheckText } from '@app/components';
import { Text, View } from '../../../../../styles/reactnative';
import NoData from '../../../../components/Common/CFlatList/NoData';
import EntryTime from '../../../../components/EntryTime';
import KrwPrice from '../../../../components/KrwPrice';
import BigNumber from 'bignumber.js';
import { ThemeContext } from '../../../../../theme/ThemeProvider';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useTradeModalStore } from '../../../../hooks/trade/modalStore';
import { getSetting, useSetting } from '../../../../hooks/user/mysetting';
import { SETTING_TYPE_SYSTEM } from '../../../../constants/SETTING';
import { useExchangeStore } from '../../../../hooks/trade/exchangeStore';
import { Button, Table, Tag } from 'antd';
import { goTo } from '../../../../hooks/navigation';
import { COLORS } from '../../../../constants';
import ShareModal from '../../../ShareModal';
import { IconShare2 } from '@tabler/icons-react';
import { formatDecimal4Truncate } from '@/utils/formatDecimal';
import useScrollLayout from '../useScrollLayout';
import { useDemoTradingStore } from '../../../../hooks/trade/demoTradingStore';
import ContractsColumn from '../Columns/ContractsColumn';
import { HiOutlineShare } from 'react-icons/hi2';
import EmptyPosition from '@/app/components/EmptyPosition';

// 헤더 스타일 (TradePositionsTable과 동일)
const headerStyle = {
  fontFamily: 'NanumSquareRound',
  fontSize: 12,
  color: '#b3b5bd',
  letterSpacing: '-0.24px',
  whiteSpace: 'nowrap' as const,
};

// 셀 데이터 공통 스타일
const cellStyle = {
  display: 'flex',
  letterSpacing: 0,
  whiteSpace: 'nowrap' as const,
  height: 17,
  alignItems: 'flex-end' as const,
  color: '#fff',
  fontFamily: 'NanumSquareRound',
  fontSize: 12,
  lineHeight: 1,
};

// 숫자 강조 스타일
const cellStyleBold = {
  fontWeight: 700,
  fontFamily: 'NanumSquareRound',
  letterSpacing: 0,
  whiteSpace: 'nowrap' as const,
  color: '#fff',
  lineHeight: 'normal',
  fontSize: 13,
};

const TradeClosedPnlTable = ({ parentHeight }) => {
  const { data: token } = useToken();
  const { isDemoMode } = useDemoTradingStore();
  const KEYURL = '/trade/closedpnl?open_close=C&ep_id=*';

  // ==========================================
  // ✅ useFetcher가 자동으로 Demo/Real API 선택
  // ==========================================
  const { data, isLoading } = useFetcher(KEYURL, false, {
    revalidateOnFocus: false,
    revalidateOnMount: true,
  });

  const containerRef = useRef<HTMLDivElement>(null);
  const { theme, isDarkMode } = useContext(ThemeContext);
  const { textw } = theme.COLORS;

  const { t } = useTranslation();
  const nav = useNavigate();

  const [shareData, setShareData] = React.useState<any>(null);

  const { data: modalStore } = useTradeModalStore();

  const { data: tradeStore } = useTradeStore();

  const { data: setting } = useSetting(SETTING_TYPE_SYSTEM);
  const equivshow = getSetting(setting, 'EQUIVSHO', 1) == 1 ? true : false;
  const { EPs } = useExchangeStore();

  let list = data?.result?.result?.list;

  const { needsScroll, headerHeight } = useScrollLayout(
    containerRef,
    list,
    parentHeight
  );

  // 이미 closed 포지션들만 오므로 추가 필터링 불필요
  // if (list) {
  //   list = list.filter((item: any) => item?.open_close === 'C');
  // }

  if (modalStore?.iscurrent) {
    list = list?.filter(
      (item: any) => item?.exchange_pairs_id == tradeStore?.ep_id
    );
  }

  // position_id 별로 fee_price를 합산하기 위한 맵 생성
  const positionFeesMap = React.useMemo(() => {
    if (!data?.result?.result?.list) return {};

    const feesMap: Record<string, number> = {};

    // 각 포지션의 orders에서 fee_price 합산
    data.result.result.list.forEach((position: any) => {
      if (position?.id && position?.orders) {
        const posId = position.id.toString();
        if (!feesMap[posId]) {
          feesMap[posId] = 0;
        }
        position.orders.forEach((order: any) => {
          feesMap[posId] += Number(order?.fee_price || 0);
        });
      }
    });

    return feesMap;
  }, [data?.result?.result?.list]);

  return (
    <TradeDetailListSection ref={containerRef}>
      {token ? null : <AuthCheckText />}

      {list?.length ? (
        <Table
          showHeader={true}
          loading={isLoading}
          bordered={false}
          rowKey={(item: any) => 'POSITION' + item?.id}
          dataSource={isLoading ? [] : list}
          expandable={{
            expandedRowRender: (position) => {
              const orders = position?.orders || [];
              return (
                <Table
                  rowKey={(order: any) => 'ORDER' + order?.id}
                  dataSource={orders}
                  pagination={false}
                  size="small"
                  style={{ marginLeft: 20 }}
                  columns={[
                    {
                      title: t('orderType'),
                      dataIndex: 'open_close',
                      key: 'open_close',
                      width: 80,
                      render: (text: any) => (
                        <Text
                          style={{
                            color:
                              text === 'O'
                                ? COLORS.lightGreen
                                : COLORS.lightRed,
                            fontWeight: 'bold',
                          }}
                        >
                          {text === 'O' ? t('open') : t('close')}
                        </Text>
                      ),
                    },
                    {
                      title: t('orderPrice'),
                      dataIndex: 'trade_price',
                      key: 'trade_price',
                      render: (text: any, order) => {
                        const EP = EPs?.find(
                          (item2: any) => +item2.id == +order?.exchange_pairs_id
                        );
                        return order?.limit_market == 'L'
                          ? BigNumber(order?.order_price || 0).toFormat(
                              EP?.dp || 3
                            )
                          : t('market');
                      },
                    },
                    {
                      title: t('executePrice'),
                      dataIndex: 'trade_price',
                      key: 'execute_price',
                      render: (text: any, order) => {
                        const EP = EPs?.find(
                          (item2: any) => +item2.id == +order?.exchange_pairs_id
                        );
                        return BigNumber(text || 0).toFormat(EP?.dp || 3);
                      },
                    },
                    {
                      title: t('qty'),
                      dataIndex: 'amount',
                      key: 'order_amount',
                      render: (text: any, order) => {
                        const EP = EPs?.find(
                          (item2: any) => +item2.id == +order?.exchange_pairs_id
                        );
                        // 포지션 데이터의 pairs를 우선 사용, 없으면 EP에서 찾기
                        const pairs = position?.pairs || EP?.pairs;
                        const coin = pairs?.split('/')[0];
                        return `${BigNumber(text || 0)
                          .multipliedBy(position?.leverage || 1)
                          .toFormat(EP?.dp2 || EP?.dp || 3)} ${coin}`;
                      },
                    },
                    {
                      title: t('tradePnl'),
                      dataIndex: 'order_pnl',
                      key: 'order_pnl',
                      render: (text: any, order) => {
                        const EP = EPs?.find(
                          (item2: any) => +item2.id == +order?.exchange_pairs_id
                        );
                        // 포지션 데이터의 pairs를 우선 사용, 없으면 EP에서 찾기
                        const pairs = position?.pairs || EP?.pairs;
                        const currency = pairs?.split('/')[1];

                        // 주문별 실현손익 계산
                        let orderPnl = 0;
                        if (order?.open_close === 'C') {
                          // 클로즈 주문인 경우만 실현손익 계산
                          // 전체 포지션의 실현손익을 주문 수량 비율로 분배
                          const totalCloseAmount =
                            position?.orders
                              ?.filter((o: any) => o.open_close === 'C')
                              ?.reduce(
                                (sum: number, o: any) =>
                                  sum + Number(o.amount || 0),
                                0
                              ) || 1;
                          const orderAmount = Number(order.amount || 0);
                          const orderRatio = orderAmount / totalCloseAmount;
                          orderPnl = (position?.pnl_price || 0) * orderRatio;
                        }

                        return (
                          <KrwPrice
                            price={orderPnl}
                            currency={currency}
                            equiv={equivshow}
                            dp={4}
                          />
                        );
                      },
                    },
                    {
                      title: t('fee'),
                      dataIndex: 'fee_price',
                      key: 'order_fee',
                      render: (text: any, order) => {
                        const EP = EPs?.find(
                          (item2: any) => +item2.id == +order?.exchange_pairs_id
                        );
                        // 포지션 데이터의 pairs를 우선 사용, 없으면 EP에서 찾기
                        const pairs = position?.pairs || EP?.pairs;
                        const currency = pairs?.split('/')[1];
                        return (
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'flex-start',
                              width: 'auto',
                              minWidth: 80,
                            }}
                          >
                            <KrwPrice
                              price={-Math.abs(text || 0)}
                              currency={currency}
                              equiv={equivshow}
                              dp={4}
                              fontSize={14}
                            />
                          </div>
                        );
                      },
                    },
                    {
                      title: t('time'),
                      dataIndex: 'created_at',
                      key: 'order_time',
                      render: (text: any, order) => {
                        const time = order?.traded_at || text;
                        if (time) {
                          return (
                            <EntryTime
                              style={{ justifyContent: 'left' }}
                              time={time}
                            />
                          );
                        }
                        return (
                          <EntryTime
                            style={{ justifyContent: 'left' }}
                            time={time}
                          />
                        );
                      },
                    },
                  ]}
                />
              );
            },
            rowExpandable: (position) => position?.orders?.length > 0,
            expandRowByClick: true,
          }}
          columns={[
            {
              width: '14.2%',
              title: <span style={headerStyle}>{t('contracts')}</span>,
              dataIndex: 'contracts',
              align: 'left',
              key: 'contracts',
              render: (text: any, item) => (
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-start',
                  }}
                >
                  <ContractsColumn item={item} />
                </div>
              ),
            },
            {
              width: '14.2%',
              title: (
                <span style={headerStyle}>
                  {t('avgEntryPrice')} / {t('avgExitPrice')}
                </span>
              ),
              dataIndex: 'trade_price',
              key: 'trade_price',
              align: 'left',
              render: (text: any, item) => {
                const EP = EPs?.find(
                  (item2: any) => +item2.id == +item?.exchange_pairs_id
                );

                // 평균 진입가는 오픈 주문들의 가중평균으로 계산
                const openOrders =
                  item?.orders?.filter(
                    (order: any) => order.open_close === 'O'
                  ) || [];
                let avgEntryPrice = 0;
                if (openOrders.length > 0) {
                  let totalAmount = 0;
                  let weightedSum = 0;
                  openOrders.forEach((order: any) => {
                    const amount = Number(order.amount || 0);
                    const price = Number(order.trade_price || 0);
                    totalAmount += amount;
                    weightedSum += amount * price;
                  });
                  avgEntryPrice =
                    totalAmount > 0 ? weightedSum / totalAmount : 0;
                }

                // 평균 청산가는 클로즈 주문들의 가중평균으로 계산
                const closeOrders =
                  item?.orders?.filter(
                    (order: any) => order.open_close === 'C'
                  ) || [];
                let avgExitPrice = 0;
                if (closeOrders.length > 0) {
                  let totalAmount = 0;
                  let weightedSum = 0;
                  closeOrders.forEach((order: any) => {
                    const amount = Number(order.amount || 0);
                    const price = Number(order.trade_price || 0);
                    totalAmount += amount;
                    weightedSum += amount * price;
                  });
                  avgExitPrice =
                    totalAmount > 0 ? weightedSum / totalAmount : 0;
                }

                return (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                    }}
                  >
                    <div style={{ ...cellStyle }}>
                      {BigNumber(avgEntryPrice).toFormat(EP?.dp || 3)}
                    </div>
                    <span
                      style={{
                        ...cellStyle,
                        color: 'rgba(255, 255, 255, 0.3)',
                      }}
                    >
                      /
                    </span>
                    <div style={{ ...cellStyle }}>
                      {BigNumber(avgExitPrice).toFormat(EP?.dp || 3)}
                    </div>
                  </div>
                );
              },
            },
            {
              width: '14.2%',
              title: <span style={headerStyle}>{t('positionStartTime')}</span>,
              dataIndex: 'created_at',
              key: 'created_at',
              align: 'left',
              render: (text: any, item) => {
                // 포지션의 created_at과 첫 번째 오픈 주문의 시간 중 더 과거인 시간 사용
                let earliestTime = item?.created_at;

                const openOrders =
                  item?.orders?.filter(
                    (order: any) => order.open_close === 'O'
                  ) || [];
                if (openOrders.length > 0) {
                  // 첫 번째 오픈 주문의 시간 (traded_at 또는 created_at)
                  const firstOrder = openOrders[0];
                  const firstOrderTime =
                    firstOrder?.traded_at || firstOrder?.created_at;

                  if (firstOrderTime && earliestTime) {
                    // 두 시간 중 더 과거인 시간 선택
                    earliestTime =
                      new Date(firstOrderTime) < new Date(earliestTime)
                        ? firstOrderTime
                        : earliestTime;
                  } else if (firstOrderTime) {
                    earliestTime = firstOrderTime;
                  }
                }

                if (earliestTime) {
                  return (
                    <EntryTime
                      time={earliestTime}
                      style={{ ...cellStyle, justifyContent: 'left' }}
                    />
                  );
                }
                return (
                  <EntryTime
                    time={earliestTime}
                    style={{ ...cellStyle, justifyContent: 'left' }}
                  />
                );
              },
            },
            {
              width: '14.2%',
              title: <span style={headerStyle}>{t('endTime')}</span>,
              dataIndex: 'trade_at',
              key: 'traded_at',
              align: 'left',
              render: (text: any, item) => {
                // 포지션의 closed_at과 마지막 주문의 traded_at 중 더 미래인 시간 사용
                let latestTime = item?.closed_at;

                const orders = item?.orders || [];
                if (orders.length > 0) {
                  // 모든 주문 중 traded_at이 가장 늦은 시간 찾기
                  const latestOrderTime = orders.reduce(
                    (latest: string | null, order: any) => {
                      const orderTime = order?.traded_at;
                      if (!orderTime) return latest;
                      if (!latest) return orderTime;
                      return new Date(orderTime) > new Date(latest)
                        ? orderTime
                        : latest;
                    },
                    null
                  );

                  if (latestOrderTime && latestTime) {
                    // 두 시간 중 더 미래인 시간 선택
                    latestTime =
                      new Date(latestOrderTime) > new Date(latestTime)
                        ? latestOrderTime
                        : latestTime;
                  } else if (latestOrderTime) {
                    latestTime = latestOrderTime;
                  }
                }

                if (latestTime) {
                  return (
                    <EntryTime
                      style={{ ...cellStyle, justifyContent: 'left' }}
                      time={latestTime}
                    />
                  );
                }
                return (
                  <EntryTime
                    style={{ ...cellStyle, justifyContent: 'left' }}
                    time={latestTime}
                  />
                );
              },
            },
            {
              width: '14.2%',
              title: <span style={headerStyle}>{t('totalQty')}</span>,
              dataIndex: 'amount',
              key: 'amount',
              align: 'left',
              render: (text: any, item) => {
                const EP = EPs?.find(
                  (item2: any) => +item2.id == +item?.exchange_pairs_id
                );
                // 포지션 데이터의 pairs를 우선 사용, 없으면 EP에서 찾기
                const pairs = item?.pairs || EP?.pairs;
                const coin = pairs?.split('/')[0];

                // 진입 주문들의 수량을 합산
                const openOrders =
                  item?.orders?.filter(
                    (order: any) => order.open_close === 'O'
                  ) || [];
                const totalEntryAmount = openOrders.reduce(
                  (total: number, order: any) => {
                    return total + Number(order.amount || 0);
                  },
                  0
                );

                return (
                  <TradeText
                    style={{
                      ...cellStyleBold,
                      justifyContent: 'flex-start',
                    }}
                  >
                    {BigNumber(totalEntryAmount)
                      .multipliedBy(item?.leverage || 1)
                      .toFormat(EP?.dp2 || EP?.dp || 3)}{' '}
                    {coin}
                  </TradeText>
                );
              },
            },
            {
              width: '14.2%',
              title: <span style={headerStyle}>{t('tradePnl')}</span>,
              dataIndex: 'realized_pl',
              key: 'realized_pl',
              align: 'left',
              render: (text: any, item) => {
                const EP = EPs?.find(
                  (item2: any) => +item2.id == +item?.exchange_pairs_id
                );
                // 포지션 데이터의 pairs를 우선 사용, 없으면 EP에서 찾기
                const pairs = item?.pairs || EP?.pairs;
                const currency = pairs?.split('/')[1];

                return (
                  <View
                    style={{
                      minWidth: 90,
                      width: '100%',
                      justifyContent: 'left',
                      flexDirection: 'row',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{ ...cellStyle, minWidth: 80 }}>
                      <KrwPrice
                        price={item?.pnl_price}
                        currency={currency}
                        ratemargin={item?.margin}
                        equiv={false}
                        dp={2}
                      />
                    </div>
                    <Button
                      // type="ghost"
                      ghost
                      style={{ border: 'none' }}
                      size="small"
                      icon={<HiOutlineShare color={'#B3B5BD'} size={16} />}
                      onClick={() => {
                        setShareData(null);
                        setTimeout(() => {
                          setShareData(item);
                        }, 100);
                      }}
                    />
                  </View>
                );
              },
            },
            {
              width: '14.2%',
              title: <span style={headerStyle}>{t('totalFee')}</span>,
              dataIndex: 'id',
              key: 'id',
              align: 'left',
              render: (text: any, item) => {
                const EP = EPs?.find(
                  (item2: any) => +item2.id == +item?.exchange_pairs_id
                );
                // 포지션 데이터의 pairs를 우선 사용, 없으면 EP에서 찾기
                const pairs = item?.pairs || EP?.pairs;
                const currency = pairs?.split('/')[1];

                // position_id에 해당하는 합산된 fee_price 사용
                const totalFeePrice = item?.id
                  ? positionFeesMap[item.id.toString()] || 0
                  : 0;

                return (
                  <div style={{ ...cellStyle, minWidth: 80 }}>
                    <KrwPrice
                      price={-Math.abs(totalFeePrice)}
                      currency={currency}
                      equiv={false}
                      dp={2}
                    />
                  </div>
                );
              },
            },
          ]}
          pagination={false}
          style={{ width: '100%', height: '100%' }}
          sticky={true}
          scroll={
            needsScroll
              ? {
                  x: 'max-content',
                  y: parentHeight - 20 - (headerHeight || 38),
                }
              : {
                  x: 'max-content',
                }
          }
          size="small"
        />
      ) : (
        <EmptyPosition type="positionHistory" />
      )}
      <ShareModal shareData={shareData} setShareData={setShareData} type={2} />
    </TradeDetailListSection>
  );
};

export default React.memo(TradeClosedPnlTable);
